import React, { Fragment, useEffect, useMemo, useState } from "react";
import Logo2 from "../../../../images/not_found_product.png";
import Loader from "../../../../layout/loader";
import SearchedProduct from "../../../searchScreen/SearchedProduct";

import "../../../searchScreen/search.css";
import "./New.css";

function TagPagination({ loading, resultPerPages, products, categoryName }) {
  const safeProducts = useMemo(() => (Array.isArray(products) ? products : []), [products]);
  const [currentPage, setCurrentPage] = useState(0);
  const pageCount = Math.max(1, Math.ceil(safeProducts.length / resultPerPages));

  const currentItems = useMemo(() => {
    const startOffset = currentPage * resultPerPages;
    return safeProducts.slice(startOffset, startOffset + resultPerPages);
  }, [currentPage, resultPerPages, safeProducts]);

  useEffect(() => {
    setCurrentPage(0);
  }, [safeProducts.length, resultPerPages]);

  const goToPage = (page) => {
    setCurrentPage(Math.max(0, Math.min(page, pageCount - 1)));
  };

  return (
    <Fragment>
      {loading ? (
        <Loader />
      ) : (
        <Fragment>
          <section className="category-results-header">
            <span>Category</span>
            <h1>{categoryName || "Shoes"}</h1>
            <p>
              {safeProducts.length} pairs found. Browse the collection without reloading the page.
            </p>
          </section>

          {currentItems.length === 0 ? (
            <Fragment>
              <div className="not-found-container">
                <img src={Logo2} alt="www.imonline.shop" />
                <span>No matches found</span>
                <h4>We could not find products in this category.</h4>
              </div>
            </Fragment>
          ) : (
            <Fragment>
              <div className="search-data-container-and-data-filters category-results-grid">
                <SearchedProduct currentItems={currentItems} loading={false} />
              </div>
            </Fragment>
          )}
        </Fragment>
      )}

      {!loading && pageCount > 1 && (
        <nav className="react-pagenation-container" aria-label="Category result pages">
          <button
            type="button"
            className="react-pagenation-prev-a"
            disabled={currentPage === 0}
            onClick={() => goToPage(currentPage - 1)}
          >
            Prev
          </button>

          {Array.from({ length: pageCount }, (_, index) => (
            <button
              type="button"
              key={index}
              className={
                index === currentPage
                  ? "react-pagenation-page-div-a react-pagenation-active-class-a"
                  : "react-pagenation-page-div-a"
              }
              onClick={() => goToPage(index)}
            >
              {index + 1}
            </button>
          ))}

          <button
            type="button"
            className="react-pagenation-prev-a"
            disabled={currentPage >= pageCount - 1}
            onClick={() => goToPage(currentPage + 1)}
          >
            Next
          </button>
        </nav>
      )}
    </Fragment>
  );
}

export default TagPagination;
